import { SprayEventId } from 'services/sprayEvents/types';
import {
    SET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION,
    REMOVE_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION,
    RESET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION
} from './constants';
import {
    SetSelectedSprayEventIdsForSubmissionAction,
    RemoveSelectedSprayEventIdsForSubmissionAction,
    ResetSelectedSprayEventIdsForSubmissionAction
} from './types';

export function setSelectedSprayEventIdsForSubmission(
    payload: SprayEventId[]
): SetSelectedSprayEventIdsForSubmissionAction {
    return {
        type: SET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION,
        payload
    };
}

export function removeSelectedSprayEventIdsForSubmission(
    payload: SprayEventId[]
): RemoveSelectedSprayEventIdsForSubmissionAction {
    return {
        type: REMOVE_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION,
        payload
    };
}

export function resetSelectedSprayEventIdsforSubmission(): ResetSelectedSprayEventIdsForSubmissionAction {
    return {
        type: RESET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION
    };
}
